import { calculatorState as store } from 'store';

/**
 * @description Получение обобщенного значения выбранных полей секции
 * @param {Object} section данные секции
 * @param {String} type тип значения счетчика
 * @returns {(String|Number)} значениe счетчика
 */
export function getTotal(section, type = 'default') {
  const index = Object.values(section).findIndex(item => item);

  switch (type) {
    case 'string':
    case 'range':
      return index !== -1 ? Object.keys(section)[index] : '';

    case 'default':
      return Object.values(section).reduce((acc, item) => acc + Number(item), 0);

    default:
      return 0;
  }
}

export function getApplyStatus(storeValues, stateValues) {
  if (storeValues) {
    return Object.keys(storeValues).every(key => {
      return storeValues[key] === stateValues[key];
    });
  }
}

const tagsParsers = {
  number: (isMobile, props) => {
    if (
      props.sectionName === 'duration' ||
      props.sectionName === 'budget' ||
      props.sectionName === 'tickets'
    ) {
      return props.name;
    }
    return isMobile ? props.value : `${props.name} - ${props.value}`;
  },
  boolean: (isMobile, props) => props.name,
  string: (isMobile, props) => props.name,
};

/**
 * @description Получение значений выбранных полей в виде тегов
 * @param {String} calculatorID
 * @param {String} type тип модалки, нужен с целью определения вида тегов
 * @param {function} t функция для локализации
 * @returns {Object} объект с списком данных для тегов и коллбеком для удаления тега
 */
export function tagsManagement(calculatorID, type, t) {
  const { updateElementInfo, updateCurrentList } = store;
  const { currentList } = store.calculators[calculatorID];
  let tags = null;

  if (type === 'preview') {
    tags = [...currentList].map(([, { sectionName, name, value }]) => {
      return {
        key: sectionName,
        counter: name,
        name: tagsParsers[typeof value](false, { name, sectionName, value, t }),
        value,
      };
    });
  } else {
    tags = [...currentList].reduce(
      (acc, [, { sectionName, name, value }]) => {
        const _acc = { ...acc };
        const data = {
          key: sectionName,
          counter: name,
          name,
          value,
        };
        typeof value === 'number' &&
        sectionName !== 'duration' &&
        sectionName !== 'budget' &&
        sectionName !== 'tickets'
          ? _acc.counters.push(data)
          : _acc.others.push(data);

        return _acc;
      },
      { counters: [], others: [] },
    );
  }

  const removeTagHandler = tag => {
    const { key, counter: name } = tag;
    let { value } = tag;

    value = typeof value === 'number' ? 0 : false;

    updateElementInfo(calculatorID, key, name, value);
    updateCurrentList(calculatorID, key, name, value);
  };

  return { tags, removeTagHandler };
}

function changeDataToArray(data) {
  return Object.entries(data).reduce(
    (acc, [fieldName, value]) => (value ? [...acc, { label: fieldName, value }] : acc),
    [],
  );
}

function changeDataToString(data) {
  const checkedField = Object.entries(data).find(([, value]) => Boolean(value));

  return checkedField ? checkedField[0] : '';
}

/**
 * @description сбор сохраненных данных калькулятора для отправки на сервер
 * @param {String} id id калькулятора
 * @return {Array} массив с данными, вид данных выбранных полей зав-т от типа поля
 * @example [{
 *    "type": "counter",
 *    "label": "Design team",
 *    "data": [ // "value": "Supply Chain"
 *      {
 *        "label": "Designer",
 *        "value": 1
 *      }
 *    ]
 * }]
 */
export function getFormData(id, sections) {
  const result = sections.reduce(
    (acc, { name, counterType, defaultOptions, items, initialStep }) => {
      const storeData = store.calculators[id].info[name];
      const info = { label: name, type: counterType };
      let data;

      switch (counterType) {
        case 'counter':
        case 'checkbox':
        case 'country':
          data = changeDataToArray(storeData);

          if (data.length) {
            info.data = data;
            return [...acc, info];
          }
          break;
        case 'radio':
        case 'chips':
          data = changeDataToString(storeData);

          if (data) {
            info.value = data;
            return [...acc, info];
          }
          break;
        case 'range':
          data = changeDataToString(storeData);
          data =
            data ||
            (info.label === 'duration' ? items[initialStep - 1] : defaultOptions[initialStep]);
          info.value = data;
          return [...acc, info];
        default:
          return false;
      }

      return acc;
    },
    [],
  );

  return result;
}

export const parseColumnsToStore = payload =>
  payload.reduce(
    (acc, item) => {
      const _acc = { ...acc };

      _acc.info[item.name] = 0;

      return _acc;
    },
    { info: {} },
  );
